import { render, staticRenderFns } from "./CoordinateModule.vue?vue&type=template&id=4bb85ca1&scoped=true"
import script from "./CoordinateModule.vue?vue&type=script&lang=js"
export * from "./CoordinateModule.vue?vue&type=script&lang=js"
import style0 from "./CoordinateModule.vue?vue&type=style&index=0&id=4bb85ca1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb85ca1",
  null
  
)

export default component.exports